import * as React from 'react';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { ILoginForm } from './types';
import KfLogo from '../../../Assets/kflogo.png';
import { Stack } from '@mui/material';
import { ConfirmLogin } from '../../../App/Packages/ConfirmLogin';

const styles = (theme: any) => ({
    card: {
        top: '10vh',
        // position: 'relative' as 'relative',
        background: '#242424',
        // boxShadow: '0px 3px 12px #00000012',
        borderRadius: '20px',
        border: '1px solid #707070',
        padding: '45px 114px 50px',
        maxWidth: '100%',
        width: '630px',
        boxSizing: 'border-box',
        // [theme.breakpoints.down('lg')]: {
        //     padding: '47px 72px',
        // },
        [theme.breakpoints.down('md')]: {
            padding: '47px 72px',
        },
        [theme.breakpoints.down('sm')]: {
            padding: '30px 40px',
            width: '500px',
        },
        [theme.breakpoints.down('xs')]: {
            padding: '25px 25px',
            width: '100%',
        },
        textAlign: 'center' as 'center',
    },
    logo: {
        marginBottom: '50px',
        width: '254px',
         [theme.breakpoints.down('sm')]: {
            width: '220px',
        },
          [theme.breakpoints.down('xs')]: {
           width: '180px',
           marginBottom: '25px',
        },
    },
    heading: {
        fonFamily: 'League Spartan',
        fontWeight: 500,
        fontSize: '32px',
        lineHeight: '38px',
        textTransform: 'uppercase' as 'uppercase',
        marginBotom: '56px',
        [theme.breakpoints.down('xs')]: {
            fontSize: '24px',
        },
    },
    field: {
        width: '100%',
        marginTop: '20px',
        borderRadius: '0px',
        '& div': {
            borderRadius: '0px',
        },
        '& input': {
            background: '#fff',
            color: '#000',
            borderRadius: '0px',
        },
    },
    submitBtnWrapper: {
        textAlign: 'center' as 'center',
    },
    submitBtn: {
        fontWeight: 600,
        background: '#db2c29',
        textTransform: 'none' as 'none',
        borderRadius: '24px',
        color: 'white',
        fontSize: '16px',
        lineHeight: '18px',
        padding: '12px 24px',
        width: '102px',
        boxSize: 'borderBox',
        height: '48px',
        letterSpacing: '0.5px',
        boxShadow: 'none',
        marginTop: '0',
        '&:disabled': {
            background: '#cccccc',
            color: '#666666',
        },
        '&:hover': {
            backgroundColor: '#B3211E',
        },
         [theme.breakpoints.down('xs')]: {
             fontSize: '15px',
             width: '96px',
             height: '40px',
          padding: '12px 8px',
        },
    },
    errors: {
        border: '3px solid #db2c29',
    },
    message: {
        padding: '0px',
        textAlign: 'center' as 'center',
        fontSize: '15px',
        lineHeight: '18px',
        margin: '30px 0px',
        color: '#ffffff',
        letterSpacing: '0.5px',
        [theme.breakpoints.down('xs')]: {
            margin: '20px 0px 10px',
           fontSize: '15px',
        },
    },
    link: {
        color: '#db2c29',
        paddingLeft: '4px',
        textDecoration: 'none',
        letterSpacing: '0.5px',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    resetPassword: {
        padding: '0px',
        textAlign: 'center' as 'center',
        lineHeight: '18px',
        fontSize: '15px',
        letterSpacing: '0.5px',
         [theme.breakpoints.down('xs')]: {
           fontSize: '15px',
        },
    },
    textField: {
        width: '100%',
        display: 'flex',
        aligItems: 'flex-start',
        flexDirection: 'column' as 'column',
        marginBottom: '35px',
        '&:last-child': {
            marginBottom: '0px',
        },
        [theme.breakpoints.down('xs')]: {
            marginBottom: '30px',
        },
    },

    labelField: {
        fontSize: '15px',
        lineHeight: '20px',
        textAlign: 'left' as 'left',
        fontWeight: 400,
        color: '#ffffff',
        letterSpacing: '0.5px',
        [theme.breakpoints.down('xs')]: {
            fontSize: '15px',
        },
    },
    inputField: {
        border: 'none',
        borderBottom: '1px solid #ffffff',
        padding: '0 4px',
        marginTop: '4px',
        background: 'transparent',
        outline: 'none',
        fontSize: '15px',
        letterSpacing: '0.7px',
        height: '38px',
        color: '#ffffff',
        caretColor: '#ffffff',
         [theme.breakpoints.down('xs')]: {
            height: '30px',
        },
    },
    inputFieldError: {
        border: 'none',
        borderBottom: '1px solid #db2c29',
        padding: '0 4px',
        height: '38px',
        marginTop: '4px',
        background: 'transparent',
        outline: 'none',
        color: '#ffffff',
        fontSize: '15px',
        letterSpacing: '0.7px',
         [theme.breakpoints.down('xs')]: {
            height: '30px',
        },
    },
    formWrapper: {
        padding: '0px',
        margin: '0 auto !important',
    },
    erroSpan: {
        textAlign: 'left' as 'left',
        color: '#db2c29',
        fontSize: '12px',
        margin: '4px 0px 0px',
         [theme.breakpoints.down('xs')]: {
            fontSize: '11px',
            margin: '2px 0px 0px',
        },
    },
});

interface IProps {
    classes: any;
    onSubmit: (method: string) => void;
    onConfirm: (method: string) => void;
    onCancel: (method: string) => void;
    form: ILoginForm;
    onChange: (
        form: 'login' | 'register',
        field: string
    ) => (e: React.ChangeEvent<HTMLInputElement>) => void;
    emailIsInvalid: (form: 'login' | 'register') => boolean;
    formIsDisabled: (form: 'login' | 'register') => boolean;
}

export const loginBox = ({
    classes,
    form,
    onChange,
    onSubmit,
    onConfirm,
    onCancel,
    emailIsInvalid,
    formIsDisabled,
}: IProps) => {
    return (
        <div className={classes.card}>
            <ConfirmLogin 
                open={form.errors.status === 402} 
                onConfirm={() => onConfirm('login')}
                onClose={() => onCancel('login')} />
            <div className={classes.heading}>
           <img src={KfLogo} className={classes.logo} />
            </div>
            <form className={classes.formWrapper}>
                <div className={classes.textField}>
                    <div className={classes.labelField + ' ' + 'font-poppins'}>Email*</div>
                    <input
                        type='email'
                        id='username'
                        onChange={onChange('login', 'username')}
                        value={form.username}
                        className={
                            form.errors.state || emailIsInvalid('login')
                                ? classes.inputFieldError
                                : classes.inputField
                        }
                        autoComplete='off'
                        placeholder=''
                        required={true}
                    ></input>
                    <span className={form.errors.state || emailIsInvalid('login') ? classes.erroSpan : ''}>
                        {emailIsInvalid('login')
                            ? 'Incorrect email'
                            : form.errors.state
                            ? 'Incorrect email'
                            : null}
                    </span>
                </div>
                <div className={classes.textField}>
                    <div className={classes.labelField}>Password*</div>
                    <input
                        type='password'
                        id='password'
                        onChange={onChange('login', 'password')}
                        value={form.password}
                        placeholder=''
                        className={
                            form.errors.state
                                ? classes.inputFieldError
                                : classes.inputField
                        }
                        autoComplete='off'
                        required={true}
                    ></input>
                    <span className={form.errors.state ? classes.erroSpan : ''}>
                        {form.errors.state ? 'Incorrect password' : ''}
                    </span>
                </div>

                <div className={classes.submitBtnWrapper}>
                    <Button
                        disabled={formIsDisabled('login')}
                        variant='contained'
                        color='primary'
                        onClick={() => onSubmit('login')}
                        className={classes.submitBtn}
                    >
                        Log In
                    </Button>
                </div>

                <div className={classes.message}>
                    <span>No account?</span>
                    <Link to='/register' className={classes.link}>
                        Register now
                    </Link>
                </div>
                <div className={classes.resetPassword}>
                    <Link to='/reset' className={classes.link}>
                        Reset Password
                    </Link>
                </div>
                {/* <TextField
                    className={classes.field}
                    required
                    id='username'
                    onChange={onChange('login', 'username')}
                    value={form.username}
                    placeholder='Email *'
                    error={form.errors.state || emailIsInvalid('login')}
                    helperText={
                        emailIsInvalid('login') ? 'Email is not valid' : ''
                    }
                    type='email'
                /> */}
                {/* <TextField
                    className={classes.field}
                    required
                    variant='outlined'
                    type='password'
                    id='password'
                    onChange={onChange('login', 'password')}
                    value={form.password}
                    placeholder='Password *'
                    error={form.errors.state}
                    helperText={form.errors.serverErrors}
                /> */}
            </form>
        </div>
    );
};

export const LoginBox = withStyles(styles)(loginBox);
